import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './simple-layout.component.html',
})
export class SimpleLayoutComponent {}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/simple-layout.component.ts